import {h, Fragment} from "preact"
import Product from "./Product"
import { useAppState } from "@nosto/preact"
import { useEffect } from "preact/hooks"

export default function Products({category}) {
    const {
        response: { products },
        response,
        loading
    } = useAppState()

    const docCount = response.products?.total ?? 0

    useEffect(() => {
        if(window.nostojs) {
            window.nostojs(api => {
                api.loadRecommendations({ skipPageViews: true, skipEvents: true })
            })
        }
        return () => { document.querySelectorAll('.ns-serp .nosto_element').forEach(el => el.remove()) };
    }, [ products?.hits ])

    useEffect(() => {
        function swatchElements(section = document) {
            let swatchElements = section.querySelectorAll("[data-swatch]");
            Array.from(swatchElements).forEach(function(element) {
                initQuickviewAction(element);
            });
        }
        // Init Quickview
        let swatchCheck = setInterval(function() {
            if(document.querySelectorAll(".ns-serp [data-swatch]").length > 0) {
                swatchElements();
                clearInterval(swatchCheck);
            }
        }, 500)
    
    
        // Init Quickview
        let quickviewCheck = setInterval(function() {
            if(document.querySelectorAll(".ns-serp [data-quick-view]").length > 0) {
                quickviewElements();
                clearInterval(quickviewCheck);
            }
        }, 500)
    }, [products])

    useEffect(() => {
        const productCards = document.querySelectorAll('.ns-serp .product-card-item'); // Adjust selector as needed
        if (productCards.length === 0) return;
      
        const rowMap = new Map();
        let currentRow = 0;
        let lastTop = productCards[0].offsetTop;
      
        productCards.forEach((card) => {
          if (card.offsetTop > lastTop) {
            currentRow++;
            lastTop = card.offsetTop;
          }
          if (!rowMap.has(currentRow)) rowMap.set(currentRow, []);
          rowMap.get(currentRow).push(card);
        });
      
        rowMap.forEach((cardsInRow) => {
            const maxHeight = Math.max(...cardsInRow.map(card => 
            card.querySelector('.product-title').offsetHeight
            ));
            cardsInRow.forEach(card => 
            card.querySelector('.product-title').style.height = `${maxHeight}px`
            );

            // Handle swatches container
            setTimeout(() => {
                const hasSwatches = cardsInRow.some(card => 
                    card.querySelector('.swatches-container').children.length > 0
                );
                
                const maxSwatchesHeight = hasSwatches ? Math.max(...cardsInRow.map(card => 
                    card.querySelector('.swatches-container').offsetHeight
                )) : 0;
            
                cardsInRow.forEach(card => {
                    const swatchesContainer = card.querySelector('.swatches-container');
                    // if (hasSwatches) {
                        swatchesContainer.style.height = `${maxSwatchesHeight}px`;
                        swatchesContainer.style.minHeight = '30px'; 
                        // let scrollTo = swatchesContainer.children.length * 15;
                        // swatchesContainer.style.paddingLeft = `calc(50% - (${scrollTo}px))`; 
                    // } else {
                        // swatchesContainer.style.height = '0';
                        // swatchesContainer.style.padding = '0';
                    // }
                });
            }, 400)
        });

      }, [products]);

    // useEffect(() => {
    //     window.scrollTo(0, 0);
    //     // when the filter changes
    // }, [useAppState()?.query?.products?.filter])

    useEffect(() => {
        window.scrollTo(0, 1);
    }, [])

    return (
        <>
            {category && 
                <div class="filter-sortby-wrapper">
                    <span class="Product-result">
                        <span class="total_products"> 
                            {docCount} products
                        </span>
                    </span>
                </div>
            }
            <div class="ns-d-flex ns-flex-wrap debug-border-red nosto-products-wrapper--inner" style={loading ? "opacity: 0.3;" : ""}>
                {products.hits.map((hit, index) => {
                    return <Product product={hit} key={hit.productId || index} index={index}/>
                })}
            </div>
            <div class="nosto_element" id="searchpage-nosto-1"></div>
        </>
    )
}
